import { all, call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import socketSubscribeSaga from '../../socket/socketSubscribe/socketSubscribe';
import { setParkSpots } from '../../../state/callPark/callParkSlice';

export function* fetchCallParkSaga() {
    try {
        // Fetch user credentials from Redux store
        const { user, domain } = yield select(selectUserCredentials);

        // API endpoint for retrieving call history (relative URL)
        const apiUrl = '?object=callqueue&action=read';
        // Parameters for the API call
        const params = {
            type: 'park',
            user: user,
            domain: domain,
            fromat: 'json',
            addDeptSite: 'inclMatchesCurrentUser'
        };

        // Make the API call with the credentials
        const response = yield call(cirrusClient.get, apiUrl, { params });
        yield put(setParkSpots(response.data));
        yield all(response.data.map((park) => call(socketSubscribeSaga, {
            payload: {
                type: 'call',
                subtype: 'queue',
                filter: park.queue_name,
            },
        })));
    } catch (error) {
        console.error('Error fetching call parks:', error);
    }
}
